import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const load = () => {
  try { return JSON.parse(localStorage.getItem("gf_cart")) || { store: null, items: [] }; }
  catch { return { store: null, items: [] }; }
};

export function CartProvider({ children }) {
  const [cart, setCart] = useState(load);
  const [pending, setPending] = useState(null); // {product, store} awaiting replace confirm

  useEffect(() => { localStorage.setItem("gf_cart", JSON.stringify(cart)); }, [cart]);

  const count = cart.items.reduce((s, i) => s + i.qty, 0);
  const subtotal = cart.items.reduce((s, i) => s + i.price * i.qty, 0);

  const qtyOf = (pid) => cart.items.find((i) => i.product_id === pid)?.qty || 0;

  const addItem = (product, store) => {
    if (cart.store && cart.store.id !== store.id && cart.items.length) {
      setPending({ product, store });
      return { conflict: true };
    }
    _add(product, store);
    return { conflict: false };
  };

  const _add = (product, store) => {
    setCart((c) => {
      const items = [...c.items];
      const idx = items.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) items[idx] = { ...items[idx], qty: items[idx].qty + 1 };
      else items.push({ product_id: product.id, name: product.name, price: product.price,
        mrp: product.mrp, image: product.image, unit: product.unit, qty: 1 });
      return { store: { id: store.id, name: store.name, delivery_fee: store.delivery_fee }, items };
    });
  };

  const confirmReplace = () => {
    if (!pending) return;
    setCart({ store: { id: pending.store.id, name: pending.store.name, delivery_fee: pending.store.delivery_fee },
      items: [{ product_id: pending.product.id, name: pending.product.name, price: pending.product.price,
        mrp: pending.product.mrp, image: pending.product.image, unit: pending.product.unit, qty: 1 }] });
    setPending(null);
  };
  const cancelReplace = () => setPending(null);

  const dec = (pid) => setCart((c) => {
    let items = c.items.map((i) => i.product_id === pid ? { ...i, qty: i.qty - 1 } : i).filter((i) => i.qty > 0);
    return { store: items.length ? c.store : null, items };
  });

  const inc = (pid) => setCart((c) => ({ ...c, items: c.items.map((i) => i.product_id === pid ? { ...i, qty: i.qty + 1 } : i) }));

  const remove = (pid) => setCart((c) => {
    const items = c.items.filter((i) => i.product_id !== pid);
    return { store: items.length ? c.store : null, items };
  });

  const clear = () => setCart({ store: null, items: [] });

  return (
    <CartContext.Provider value={{ cart, count, subtotal, qtyOf, addItem, inc, dec, remove, clear,
      pending, confirmReplace, cancelReplace }}>
      {children}
    </CartContext.Provider>
  );
}
